/*
 * Module for the Continuance Beneficiary Step of the MemberDirect Retirement Application wizard
*/
rs.module("content/benefits/retirementapplication/continuancebeneficiarystep",

    ["common/select-helper", "common/visibility", "controls/navigation/wizard"],

    function (selectHelper, visibility, wizard) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var beneficiarySelect = stepContainer.js(jsSelectors.beneficiarySelect);
            var lastNameTextBox = stepContainer.js(jsSelectors.lastNameTextBox);
            var firstNameTextBox = stepContainer.js(jsSelectors.firstNameTextBox);
            var middleNameTextBox = stepContainer.js(jsSelectors.middleNameTextBox);
            var ssnTextBox = stepContainer.js(jsSelectors.ssnTextBox);
            var ssnMaskedTextBox = stepContainer.js(jsSelectors.ssnMaskedTextBox);
            var ssnMaskedHidden = stepContainer.js(jsSelectors.ssnMaskedHidden);
            var relationshipSelect = stepContainer.js(jsSelectors.relationshipSelect);
            var relationshipSelectHelper = selectHelper.getHelper(relationshipSelect);
            var birthDatePicker = stepContainer.js(jsSelectors.birthDatePicker);
            var useMembersAddressCheckbox = stepContainer.js(jsSelectors.useMembersAddressCheckbox);
            var addressContainer = stepContainer.js(jsSelectors.addressContainer);
            var address1TextBox = addressContainer.js(jsSelectors.address1TextBox);
            var address2TextBox = addressContainer.js(jsSelectors.address2TextBox);
            var cityTextBox = addressContainer.js(jsSelectors.cityTextBox);
            var stateSelect = addressContainer.js(jsSelectors.stateSelect);
            var stateSelectHelper = selectHelper.getHelper(stateSelect);
            var zipCodeTextBox = addressContainer.js(jsSelectors.zipCodeTextBox);
            var emailAddressTextBox = stepContainer.js(jsSelectors.emailAddressTextBox);
            var cellPhoneTextBox = stepContainer.js(jsSelectors.cellPhoneTextBox);
            var homePhoneTextBox = stepContainer.js(jsSelectors.homePhoneTextBox);

            // Handle beneficiarySelect changed
            beneficiarySelect.change(beneficiarySelectChanged);

            // Handle useMembersAddressCheckbox changed
            useMembersAddressCheckbox.change(function () {

                var useMembersAddress = useMembersAddressCheckbox.is(":checked");

                visibility.setVisible(addressContainer, !useMembersAddress);

                address1TextBox.clearErrors();
                address2TextBox.clearErrors();
                cityTextBox.clearErrors();
                stateSelect.clearErrors();
                zipCodeTextBox.clearErrors();
            });

            function beneficiarySelectChanged() {

                // Clear all the fields
                lastNameTextBox.val('').clearErrors();
                firstNameTextBox.val('').clearErrors();
                middleNameTextBox.val('').clearErrors();
                ssnTextBox.val('').clearErrors();
                ssnMaskedTextBox.val('').clearErrors();
                ssnMaskedHidden.val('').clearErrors();
                relationshipSelectHelper.setValue(null);
                relationshipSelect.clearErrors();
                birthDatePicker.val('').clearErrors();
                address1TextBox.val('').clearErrors();
                address2TextBox.val('').clearErrors();
                cityTextBox.val('').clearErrors();
                stateSelectHelper.setValue(null);
                stateSelect.clearErrors();
                zipCodeTextBox.val('').clearErrors();
                emailAddressTextBox.val('').clearErrors();
                cellPhoneTextBox.val('').clearErrors();
                homePhoneTextBox.val('').clearErrors();

                var selectedValue = beneficiarySelect.val();

                if (selectedValue === "-1") {
                    visibility.setVisible(ssnMaskedTextBox, false);
                    visibility.setVisible(ssnTextBox, true);
                }
                else {
                    $.get(
                        {
                            url: backendUrls.getContinuanceBeneficiary,
                            headers: wizard.getNavigationToken(),
                            data: {
                                accountPartyKey: selectedValue
                            }
                        },
                        function (data) {
                            lastNameTextBox.val(data.lastName);
                            firstNameTextBox.val(data.firstName);
                            middleNameTextBox.val(data.middleName);
                            ssnTextBox.val(data.tin);

                            if (data.ssnLast4 && data.ssnLast4.trim() !== "") {
                                ssnMaskedTextBox.val(data.ssnLast4);
                                ssnMaskedHidden.val(data.ssnLast4);
                                visibility.setVisible(ssnMaskedTextBox, true);
                                visibility.setVisible(ssnTextBox, false);
                            }
                            else {
                                visibility.setVisible(ssnMaskedTextBox, false);
                                visibility.setVisible(ssnTextBox, true);
                            }

                            if (data.relationship) {
                                relationshipSelectHelper.setValue(data.relationship.key);
                            }

                            birthDatePicker.val(data.birthDate ? new Date(data.birthDate).toISODateString() : null);
                            address1TextBox.val(data.address1);
                            address2TextBox.val(data.address2);
                            cityTextBox.val(data.city);

                            if (data.state) {
                                stateSelectHelper.setValue(data.state.key);
                            }

                            zipCodeTextBox.val(data.zipCode);
                            emailAddressTextBox.val(data.emailAddress);
                            cellPhoneTextBox.val(data.cellPhone);
                            homePhoneTextBox.val(data.homePhone);
                        }
                    );
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);